import { useFormContext } from "react-hook-form";
import { CheckboxField } from "../fields/CheckboxField";

type Props = {
  label?: string;
  name: string;
  value?: any;
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;

export const CheckboxInput = ({
  label,
  name,
  value,
  onChange,
  ...rest
}: Props) => {
  const { register } = useFormContext();
  const { ref, onChange: hookOnChange, ...hookFormProps } = register(
    name as string
  );

  const customOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    hookOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <CheckboxField
      label={label}
      value={value}
      innerRef={ref}
      onChange={customOnChange}
      {...rest}
      {...hookFormProps}
    />
  );
};
